var map = {
	"./ziliao_banner.jpg": "3f14",
	"./ziliao_banner_en.jpg": "06cd",
	"./ziliao_banner_es.jpg": "fa5b",
	"./ziliao_banner_hk.jpg": "87d1",
	"./ziliao_banner_pt.jpg": "f8c9",
	"./ziliao_banner_tr.jpg": "e48d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df8a";